import React, { useEffect, useRef, useState } from 'react';
import { Col, Container, Row, Button, Form } from "react-bootstrap";
import { Icon } from '@iconify/react';
import { Dropdown } from 'primereact/dropdown';
import { Tooltip as ReactTooltip } from "react-tooltip";
import ReactQuill from 'react-quill';
import ImagesUploader from 'react-images-uploader';
import { useNavigate } from "react-router-dom";
import GPT from '../../../components/Veiculos/GPT';
import ReactDOMServer from 'react-dom/server';
import { useParams } from "react-router-dom";

//components
import Navbar from "../../../components/Navbar"
import Alert from "../../../components/Alert"
import FileUpload from "../../../components/Veiculos/FileUpload"
import Alerts from '../../../components/Alerts';
import NewModelo from '../../../components/Veiculos/NewModelo'
import NewVidros from '../../../components/Veiculos/NewVidros'
import NewBlindagens from '../../../components/Veiculos/NewBlindagens'
import NewGarantia from '../../../components/Veiculos/NewGarantia'

//styles

import 'react-images-uploader/styles.css';
import 'react-images-uploader/font.css';
import api from '../../../services/apiIdz';
import { useAuth } from '../../../context/useAuth';
import FileUploadSingle from '../../../components/Veiculos/FileUploadSingle';
import IdzFileUpload from '../../../components/Veiculos/idzFileUpload';
import ReaisInput from '../../../components/ReaisInput';
import KmInput from '../../../components/KmInput';
import ButtonLoadingRing from '../../../components/ButtonLoading';
import './Novo.scss';
function Veiculos() {

    const { id } = useParams();
    const isEditing = !!id;

    const { token, user, loading } = useAuth()
    const finalizarButton = useRef(null)
    const navigate = useNavigate()

    const [isVisible, setIsVisible] = useState(false);
    const [isTitle, setTitle] = useState('');
    const [initDescription, setDescription] = useState('');
    const [initType, setType] = useState('');
    const [ativo, setAtivo] = useState(false);


    const [statusMultiplos, setStatusMultiplos] = useState('on'); // Estado inicial
    const [multiplos, setMultiplos] = useState('');

    const handleClickStatusMultiplos = (newStatus) => {
        setStatusMultiplos(newStatus);
        if (newStatus === 'on') {
            setMultiplos('Ativo');
        } else if (newStatus === 'off') {
            setMultiplos('Inativo');
        } else if (newStatus === 'vendido') {
            setMultiplos('Vendido');
        } 
    };

    useEffect(() => {
        if(multiplos){
          handleInputValueChange(multiplos, "status")  
        } 
    }, [multiplos])



    const [show, setShowModal] = useState(false);
    const [showBlindagens, setShowModalBlindagens] = useState(false);
    const [showVidros, setShowModalVidros] = useState(false);
    const [showGarantia, setShowModalGarantia] = useState(false);

    const showModal = () => {
        setShowModal(!show);
    };
    const showModalBlindagens = () => {
        setShowModalBlindagens(!showBlindagens);
    };
    const showModalVidros = () => {
        setShowModalVidros(!showVidros);
    };
    const showModalGarantia = () => {
        setShowModalGarantia(!showGarantia);
    };

    const handleAlert = (title, description, type) => {
        setIsVisible(true)
        setTitle(title);
        setDescription(description);
        setType(type);
    }

    useEffect(() => {
        if (isVisible) {
            setTimeout(() => {
                setTimeout(() => {
                    setIsVisible(false);
                }, 200);
            }, 8000);
        }
    }, [isVisible])


    const getMarcas = async () => {
    try {
        const tv = Number(configData.tipo_veiculo) || 1;
        const response = await api.get(`/api/marcas`, {
        headers: { 'Authorization': process.env.REACT_APP_API_KEY },
        params: { tipo_veiculo: tv }
        });

        if (response.data && Array.isArray(response.data)) {
        const lista = response.data.map(marca => ({ label: marca.titulo, value: marca.id }));
        setMarcas(lista);
        } else {
        setMarcas([]);
        }
    } catch (error) {
        console.error("Erro ao buscar marcas:", error);
        setMarcas([]);
    }
    };
        

    useEffect(() => {
        if (user) {
            getMarcas();
        }
    }, [user]);
    
    const getModelos = async (marca_id) => {
        if (!marca_id) { setModelos([]); return; }
        try {
            const tv = Number(configData.tipo_veiculo) || 1;
            const response = await api.get(`/api/modelos/marca/${marca_id}`, {
            headers: { 'Authorization': process.env.REACT_APP_API_KEY },
            params: { tipo_veiculo: tv }
            });

            if (response.data && Array.isArray(response.data)) {
            const lista = response.data.map(modelo => ({ label: modelo.titulo, value: modelo.id }));
            setModelos(lista);
            } else {
            setModelos([]);
            }
        } catch (error) {
            console.error("Erro ao buscar modelos:", error);
            setModelos([]);
        }
        };

    const getVersoes = async (modelo_id) => {
        if (!modelo_id) {
            setVersoes([]);
            return;
        }
    
        try {
            const response = await api.get(`/api/versao/modelo/${modelo_id}`, {
                headers: {
                    'Authorization': process.env.REACT_APP_API_KEY
                }
            });

            console.log("[VERSÕES]:", response.data);
    
            if (response.data && Array.isArray(response.data)) {
                console.log("[VERSÕES]:", response.data);
    
                const lista = response.data.map(versao => ({
                    label: versao.titulo,
                    value: versao.id
                }));
    
                console.log("Lista de versões:", lista);
                setVersoes(lista);
            } else {
                setVersoes([]); // Limpa caso não haja retorno
            }
        } catch (error) {
            console.error("Erro ao buscar versões:", error);
        }
    };

    const getAnosVersao = async (versao_id) => {
        if (!versao_id) {
            setAnosModelo([]); // Se não houver versão selecionada, limpa a lista de anos
            return;
        }
    
        try {
            const response = await api.get(`/api/versao/${versao_id}/anos`, {
                headers: {
                    'Authorization': process.env.REACT_APP_API_KEY
                }
            });
    
            if (response.data && Array.isArray(response.data)) {
                console.log("[ANOS VERSÃO]:", response.data);
    
                const lista = response.data.map(ano => ({
                    label: ano, // Mantém o ano como label
                    value: ano
                }));
    
                console.log("Lista de anos:", lista);
                setAnosModelo(lista);
            } else {
                setAnosModelo([]); // Limpa caso não haja retorno
            }
        } catch (error) {
            console.error("Erro ao buscar anos da versão:", error);
        }
    };


    const [cores, setCores] = useState([]);
    const [cambio, setCambio] = useState([]);
    const [portas, setPortas] = useState([]);

    
    useEffect(() => {
        if (user) {
            fetchCores();
            fetchCambio();
            fetchPortas();
        }
    }, [user]);

    const fetchCores = async () => {
        try {
            const response = await api.get(`/api/cores`, {
                headers: { 'Authorization': process.env.REACT_APP_API_KEY }
            });

            if (response.data && Array.isArray(response.data)) {
                setCores(response.data.map(cor => ({
                    label: cor.titulo,
                    value: cor.id
                })));
            } else {
                console.warn("Resposta da API de cores não contém uma lista válida.");
                setCores([]);
            }
        } catch (error) {
            console.error("Erro ao buscar as cores:", error);
        }
    };

    const fetchCambio = async () => {
        try {
            const response = await api.get(`/api/cambio`, {
                headers: { 'Authorization': process.env.REACT_APP_API_KEY }
            });

            if (response.data && Array.isArray(response.data)) {
                setCambio(response.data.map(c => ({
                    label: c.titulo,
                    value: c.id
                })));
            } else {
                console.warn("Resposta da API de câmbio não contém uma lista válida.");
                setCambio([]);
            }
        } catch (error) {
            console.error("Erro ao buscar os câmbios:", error);
        }
    };

    const fetchPortas = async () => {
        try {
            const response = await api.get(`/api/portas`, {
                headers: { 'Authorization': process.env.REACT_APP_API_KEY }
            });

            if (response.data && Array.isArray(response.data)) {
                setPortas(response.data.map(p => ({
                    label: p.titulo,
                    value: p.id
                })));
            } else {
                console.warn("Resposta da API de portas não contém uma lista válida.");
                setPortas([]);
            }
        } catch (error) {
            console.error("Erro ao buscar as portas:", error);
        }
    };
        
        
    const [combustivelList, setCombustivelList] = useState([])
    const [combustivelAuxList, setCombustivelAuxList] = useState([])

    useEffect(() => {
        const fetchCombustiveis = async () => {
            try {
                const response = await api.get(`/api/combustivel`, {
                    headers: {
                        'Authorization': process.env.REACT_APP_API_KEY,
                    },
                });
                if (response.data) {
                    const listaCombustiveis = response.data.map((combustivel) => ({
                        label: combustivel.titulo, // 'titulo' será exibido no dropdown
                        value: combustivel.id,    // 'id' será usado como identificador único
                    }));
                    setCombustivelList(listaCombustiveis); // Atualiza o estado
                }
            } catch (error) {
                console.error("Erro ao buscar os combustíveis:", error);
            }
        };

        fetchCombustiveis();
    }, []);

    
    const [fipe, setFipe] = useState(0)


    const getModelosDetalhes = async (modelo_id, ano) => {
        await api.get(`/api/modelos/${modelo_id}/ano/${ano}`, {
            headers: {
                'Authorization': process.env.REACT_APP_API_KEY
            }
        }).then(r => {
            if (r.data) {
                console.log("[DETALHES_MODELO]:", r.data)

                let listaCombustivel = []
                let auxModelo = []
                for (let modelo of r.data) {
                    listaCombustivel.push({ label: modelo.combustivel, value: modelo.combustivel })
                    auxModelo.push(modelo)
                }

                // setCombustivelList(listaCombustivel)

                setCombustivelList([
                    { label: 'Gasolina', value: 'Gasolina' },
                    { label: 'Etanol', value: 'Etanol' },
                    { label: 'Flex', value: 'Flex ' },
                    { label: 'Diesel', value: 'Diesel' },
                    { label: 'GNV', value: 'GNV' },
                    { label: 'Híbrido', value: 'Híbrido' },
                    { label: 'Eletrico', value: 'Eletrico' }
                ])

                // console.log("[COMBUSTIVEL_AUX_LIST]", auxModelo)
                // let filtered = auxModelo.filter(d => d.combustivel.toLowerCase() == configData["combustivel"].toLowerCase())
                // console.log("[FILTERED]", filtered)

                // if (filtered.length > 0) {
                //     setFipe(filtered[0].preco)
                // } else {
                //     console.log("Não encontrou combustivel semelhante, buscando o maior valor", auxModelo)

                //     let maioresPrecos = auxModelo.map(function (produto) {
                //         return converterPrecoParaNumero(produto.preco);
                //     });

                //     var maiorPrecoNumero = Math.max(...maioresPrecos);
                //     var maiorPrecoFormatado = maiorPrecoNumero.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });;

                //     console.log("O maior preço entre os auxModelo é:", maiorPrecoFormatado);
                //     setFipe(maiorPrecoFormatado)
                // }

                setCombustivelAuxList(auxModelo)
            }
        })
    }

    const [opcionaisChumbado, setOpcionaisChumbado] = useState([
        { label: "Air Bag", value: "Air Bag" },
        { label: "Alarme", value: "Alarme" },
        { label: "Ar condicionado", value: "Ar condicionado" },
        { label: "Direção hidráulica", value: "Direção hidráulica" },
        { label: "Freio ABS", value: "Freio ABS" },
        { label: "Travas elétricas", value: "Travas elétricas" },
        { label: "Vidros elétricos", value: "Vidros elétricos" },
        { label: "Ar quente", value: "Ar quente" },
        { label: "Banco do motorista com ajuste de altura", value: "Banco do motorista com ajuste de altura" },
        { label: "Bancos em couro", value: "Bancos em couro" },
        { label: "Computador de bordo", value: "Computador de bordo" },
        { label: "Desembaçador traseiro", value: "Desembaçador traseiro" },
        { label: "Rodas de liga leve", value: "Rodas de liga leve" },
        { label: "Teto solar", value: "Teto solar" },
        { label: "Tração 4x4", value: "Tração 4x4" }
    ])

    const [opcionais, setOpcionais] = useState([]);

    const getOpcionais = async () => {
        try {
            const response = await api.get(`/api/opcionais`, {
                headers: {
                    'Authorization': process.env.REACT_APP_API_KEY
                }
            });
    
            if (response.data && Array.isArray(response.data)) {
                console.log("[OPCIONAIS]:", response.data);
    
                const lista = response.data.map(opcional => ({
                    label: opcional.nome_opcional, // Nome do opcional vindo da API
                    value: opcional.id // ID do opcional
                }));
    
                setOpcionais(lista);
            } else {
                setOpcionais([]); // Garante que a lista seja limpa caso não haja retorno
            }
        } catch (error) {
            console.error("Erro ao buscar opcionais:", error);
        }
    };

    useEffect(() => {
        getOpcionais();
    }, []);



    const getAnosModelo = async (modelo_id) => {
        console.log(modelo_id)
        await api.get(`/api/modelos/${modelo_id}/anos`, {
            headers: {
                'Authorization': process.env.REACT_APP_API_KEY
            }
        }).then(r => {
            if (r.data) {
                console.log("[ANOS_MODELO]:", r.data)
                let lista = [

                ]
                for (let ano of r.data) {
                    lista.push({ label: ano, value: ano })
                }
                setAnosModelo(lista)
            }
        })
    }

    const [sending, setSending] = useState(false)

    const buildFotos = (fotos = []) => {
    return (fotos || [])
        .filter(f => f && (f.imagem || f.id)) // evita itens vazios
        .map(f => (
        f.id
            ? { id: f.id, imagem: f.imagem } // existente -> sempre id + imagem
            : { imagem: f.imagem }           // nova -> só imagem
        ));
    };

  const postVeiculo = async () => {
  if (saveButton.current) saveButton.current.disabled = true;
  setSending(true);

  try {
    const dataToSend = {
      ...configData,
      cambio_id:        configData.cambio       || null,
      combustivel_id:   configData.combustivel  || null,
      cor_id:           configData.cor          || null,
      portas:           configData.portas       || null,
      fotos:            buildFotos(configData.fotos || []),
      blindagem: configData.blindagem ? {
        ...configData.blindagem,
        tipo_blindagem: mapToId(blindagem, configData.blindagem?.tipo_blindagem),
        tipo_vidro:     mapToId(vidros,     configData.blindagem?.tipo_vidro),
        garantia_vidro: mapToId(garantia,   configData.blindagem?.garantia_vidro),
      } : null,
    };

    // chama API
    const response = isEditing
      ? await api.put(`/api/veiculos/${id}`, dataToSend, {
          headers: { 'Authorization': process.env.REACT_APP_API_KEY, "Token": token }
        })
      : await api.post(`/api/veiculos`, dataToSend, {
          headers: { 'Authorization': process.env.REACT_APP_API_KEY, "Token": token }
        });

    if (response.status === 200) {
      handleAlert("Sucesso", `Veículo salvo com ID ${response.data}`, "success");
      setTimeout(() => navigate("/veiculos"), 4000);
    } else {
      handleAlert("Erro", "Erro ao salvar os dados.", "danger");
    }
  } catch (error) {
    console.error("Erro ao salvar veículo:", error);
    handleAlert("Erro", "Erro na comunicação com o servidor.", "danger");
  } finally {
    setSending(false);
    if (saveButton.current) saveButton.current.disabled = false;
  }
};


    const [intInformation, setInformation] = useState(true);
    const [intOptions, setOptions] = useState(false);
    const [intDetail, setDetail] = useState(false);
    const [intPhoto, setPhoto] = useState(false);
    const [intUpload, setUpload] = useState(false);
    const [intSeo, setSeo] = useState(false);



    const [isChecked, setIsChecked] = useState(false);
    const [inputs, setInputs] = useState(['']);
    const [tours, setTours] = useState(['']);
    const [soms, setSoms] = useState(['']);

    const [versaoSelecionada, setVersaoSelecionada] = useState(null);

    // const [tags, setTags] = useState([]);
    const [inputValue, setInputValue] = useState('');

    // const handleKeyDown = (e) => {
    //     if (e.key === 'Enter') {
    //         e.preventDefault(); // Evita que o formulário seja enviado ao pressionar Enter
    //         const newTag = inputValue.trim();
    //         if (newTag && tags.length < 4) { // Verifica se há menos de 4 tags
    //             setTags([...tags, newTag]);
    //             setInputValue('');
    //         }
    //     }
    // };

    // useEffect(() => {
    //     if (tags) {
    //         handleInputValueChange(tags, "seo_keywords")
    //         setConfigData({
    //             ...configData,
    //             seo: {
    //                 ...configData["seo"],
    //                 keywords: tags
    //             }
    //         })
    //     }
    // }, [tags])

    // const handleRemoveTag = (indexToRemove) => {
    //     setTags(tags.filter((tag, index) => index !== indexToRemove));
    // };

    const handleInputsDynamic = (value, i) => {
        if (inputs) {
            const inputData = [...inputs]
            inputData[i] = value
            setInputs(inputData)
        }
    }
    const handleToursDynamic = (value, i) => {
        if (tours) {
            const tourData = [...tours]
            tourData[i] = value
            setTours(tourData)
        }
    }
    const handleSomsDynamic = (value, i) => {
        if (soms) {
            const somData = [...soms]
            somData[i] = value
            setSoms(somData)
        }
    }

    useEffect(()=>{
        console.log(configData)
    },[ativo])

    useEffect(() => {
        if (inputs) {
            handleInputValueChange(inputs, "videos")
        }
    }, [inputs])

    useEffect(() => {
        if (tours) {
            handleInputValueChange(tours, "tour")
        }
    }, [tours])

    useEffect(() => {
        if (soms) {
            handleInputValueChange(soms, "som")
        }
    }, [soms])

    const handleVersaoChange = (event) => {
        setVersaoSelecionada(event.value);
    };

    const handleAddInput = () => {
        if (inputs.length < 3) {
            setInputs([...inputs, '']);
        }
    };


    const handleRemoveInput = (index) => {
        const newInputs = [...inputs];
        newInputs.splice(index, 1);
        setInputs(newInputs);
    };



const handleCheckChange = (e) => {
  const checked = e.target.checked;
  setIsChecked(checked);
  setConfigData(prev => ({
    ...prev,
    blindagem: {
      ...prev.blindagem,
      blindado: checked ? 1 : 0,
      // mantém IDs já selecionados quando liga; limpa quando desliga
      tipo_blindagem: checked ? (prev.blindagem?.tipo_blindagem ?? null) : null,
      tipo_vidro: checked ? (prev.blindagem?.tipo_vidro ?? null) : null,
      garantia_vidro: checked ? (prev.blindagem?.garantia_vidro ?? null) : null,
    }
  }));
};

    function Phases(i) {
        setInformation(i == 'Information' ? true : false)
        setOptions(i == 'Options' ? true : false)
        setDetail(i == 'Detail' ? true : false)
        setPhoto(i == 'Photo' ? true : false)
        setUpload(i == 'Upload' ? true : false)
        setSeo(i == 'Seo' ? true : false)
    }

    const [marcas, setMarcas] = useState([]);
    const [modelos, setModelos] = useState([]);
    const [versoes, setVersoes] = useState([]);
    const [anosModelo, setAnosModelo] = useState([]);
    





  


    const placeholdersOpcionais = [
        { label: 'Airbag', value: 'Airbag', disabled: false },
        { label: 'Ar-Condicionado', value: 'Ar-Condicionado', disabled: false },
        { label: 'Direção Elétrica', value: 'Direção Elétrica', disabled: false },
        { label: 'Bancos em Couro', value: 'Bancos em Couro', disabled: false }
    ];



    const [blindagem, setBlindagem] = useState([])
    const [vidros, setVidros] = useState([])
    const [garantia, setGarantia] = useState([])

    const getBlindagem = async () => {
        await api.get(`/api/atributos?atributo=tipo_blindagem`, {
            headers: {
                'Authorization': process.env.REACT_APP_API_KEY
            }
        }).then(r => {
            if (r.data) {
                let lista = [

                ]
                for (let marca of r.data.opcoes) {
                    lista.push({ label: marca.label, value: marca.id })
                }
                setBlindagem(lista)
            }
        })
    }

    const getVidros = async () => {
        await api.get(`/api/atributos?atributo=tipo_vidro`, {
            headers: {
                'Authorization': process.env.REACT_APP_API_KEY
            }
        }).then(r => {
            if (r.data) {
                let lista = [

                ]
                for (let marca of r.data.opcoes) {
                    lista.push({ label: marca.label, value: marca.id })
                }
                setVidros(lista)
            }
        })
    }

    const getGarantia = async () => {
        await api.get(`/api/atributos?atributo=garantia_vidro`, {
            headers: {
                'Authorization': process.env.REACT_APP_API_KEY
            }
        }).then(r => {
            if (r.data) {
                let lista = []
                for (let marca of r.data.opcoes) {
                    lista.push({ label: marca.label, value: marca.id })
                }
                setGarantia(lista)
            }
        })
    }

    useEffect(() => {
        getBlindagem();
        getVidros();
        getGarantia();
    }, [])

    const [configData, setConfigData] = useState({
        detalhes: {
            chamada: '',
            descricao: '',
            detalhes_interno: '',
            detalhes_externo: ''
        },
        pagina_produto: {
            titulo: "",
            imagem: ""
        },
        pagina_busca: {
            titulo: "",
            imagem: ""
        },
        status: "Ativo",
        tipo_veiculo: 1
    });

    useEffect(() => {
        if (configData["marca_id"]) {
            console.log(`Buscando modelos para a marca: ${configData["marca_id"]}`);
            getModelos(configData["marca_id"]);
        } else {
            setModelos([]); 
        }
    }, [configData["marca_id"]]);


    useEffect(() => {
        if (configData?.modelo_id) {
            console.log(`Buscando versões para o modelo: ${configData.modelo_id}`);
            getVersoes(configData.modelo_id);
        } else {
            setVersoes([]);
        }
    }, [configData.modelo_id]);


    useEffect(() => {
        if (configData?.versao_id) {
            console.log(`Buscando anos para a versão: ${configData.versao_id}`);
            getAnosVersao(configData.versao_id);
        } else {
            setAnosModelo([]); 
        }
    }, [configData.versao_id]);
    

    useEffect(()=>{
        console.log(configData);
    },[configData])

    function converterPrecoParaNumero(precoString) {
        var precoSemSimbolo = precoString.replace(/[^\d,]/g, '');
        return parseFloat(precoSemSimbolo.replace(',', '.'));
    }

    useEffect(() => {
        if (configData['combustivel']) {
            console.log("[COMBUSTIVEL_AUX_LIST]", combustivelAuxList)
            let filtered = combustivelAuxList.filter(d => d.combustivel.toLowerCase() == configData["combustivel"].toLowerCase())
            console.log("[FILTERED]", filtered)

            if (filtered.length > 0) {
                setFipe(filtered[0].preco)
            } else {
                console.log("Não encontrou combustivel semelhante, buscando o maior valor", combustivelAuxList)

                let maioresPrecos = combustivelAuxList.map(function (produto) {
                    return converterPrecoParaNumero(produto.preco);
                });

                var maiorPrecoNumero = Math.max(...maioresPrecos);
                var maiorPrecoFormatado = maiorPrecoNumero.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });;

                console.log("O maior preço entre os auxModelo é:", maiorPrecoFormatado);
                setFipe(maiorPrecoFormatado)
            }
        }
    }, [configData['combustivel']])



    const handleInputValueChange = (value, field) => {
        setConfigData(prevData => ({
            ...prevData,
            [field]: value
        }));
    };

    useEffect(() => {
        // sempre que trocar o tipo (1 carro / 2 moto), zere dependências
        setConfigData(prev => ({
            ...prev,
            marca_id: null,
            modelo_id: null,
            versao_id: null,
            ano_modelo: null,
            ano_fabricacao: null
        }));
        setModelos([]);
        setVersoes([]);
        setAnosModelo([]);

        if (user) getMarcas();
        }, [configData.tipo_veiculo, user]);

    const handleInputChange = (e, field) => {
    let val = e.value;
    if (field === "tipo_veiculo") val = Number(val); // força número
    setConfigData(prev => ({ ...prev, [field]: val }));
    };



    function getBase64Image(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    const [newUserInfo, setNewUserInfo] = useState({
        profileImages: []
    });

    useEffect(() => {
        console.log(newUserInfo)
    }, [newUserInfo])

    const updateUploadedFiles = async (files, tipo) => {
    const images = [];
    for (let file of files) {
        if (file.type?.includes("image")) {
        const base64 = await getBase64Image(file);
        images.push({ tipo, imagem: base64 }); // sem id
        }
    }
    setNewUserInfo({ ...newUserInfo, profileImages: files });
    handleInputValueChange(images, "fotos");
    };

    const updateUploadedMultipleFiles = async (files, tipo) => {
    if (!files) return;
    const images = files.map(file => ({
        ...(file.id ? { id: file.id } : {}),
        tipo,
        imagem: file.imagem || file.src // garante imagem sempre
    }));
    handleInputValueChange(images, "fotos");
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        //logic to create new user...
    };


    // Opcionais

    const [opcionaisSelecionados, setOpcionaisSelecionados] = useState([]);
    const [diferenciaisDigitados, setDiferenciaisDigitados] = useState('');
    const [optionsDropdown, setOptionsDropdown] = useState(placeholdersOpcionais);

    useEffect(() => {
        if (opcionaisSelecionados) {
            console.log("opcionaisSelecionados", opcionaisSelecionados)
            handleInputValueChange(opcionaisSelecionados, "opcionais")
        }
    }, [opcionaisSelecionados])

    const handleDropdownChange = (event) => {
        let selectedOption = event.value;
    
        console.log("[handleDropdownChange] selectedOption:", selectedOption);
    
        // Se for um objeto, extraímos a label
        if (selectedOption && typeof selectedOption === "object" && selectedOption.label) {
            selectedOption = selectedOption.label;
        }
    
        // Se for um número (ID), tentamos encontrar a label correspondente na lista de opcionais
        if (typeof selectedOption === "number") {
            const opcionalEncontrado = opcionais.find(opc => opc.value === selectedOption);
            selectedOption = opcionalEncontrado ? opcionalEncontrado.label : `Desconhecido (${selectedOption})`;
            console.warn("[handleDropdownChange] Corrigido ID para label:", selectedOption);
        }
    
        // Adiciona ao estado apenas a label
        setOpcionaisSelecionados(prevState => [...prevState, selectedOption]);
    
        console.log("[handleDropdownChange] Lista Atualizada:", opcionaisSelecionados);
    };
    

    useEffect(() => {
        if (opcionaisSelecionados.length > 0 && opcionais.length > 0) {
            console.log("🔄 Atualizando opcionaisSelecionados:", opcionaisSelecionados);
    
            // Converte os opcionais conhecidos para seus respectivos IDs
            const idsOpcionais = opcionaisSelecionados.map(opcional => {
                // 🔥 Ajuste aqui: Verifica se é um objeto ou uma string
                if (typeof opcional === "object" && opcional.opcional) {
                    opcional = opcional.opcional; // Extrai o nome se for objeto
                }
    
                const encontrado = opcionais.find(o => o.label.toLowerCase() === opcional.toLowerCase());
                return encontrado ? encontrado.value : opcional; // Se não encontrar ID, mantém o texto original
            });
    
            console.log("✅ opcionaisSelecionados (IDs e diferenciais manuais preservados):", idsOpcionais);
    
            // Evita atualização desnecessária para não gerar loop infinito
            if (JSON.stringify(idsOpcionais) !== JSON.stringify(configData.opcionais)) {
                handleInputValueChange(idsOpcionais, "opcionais");
            }
        }
    }, [opcionaisSelecionados, opcionais]); // 🔥 Mantém dependências necessárias
    

    useEffect(() => {
        console.log("opcionais alterados", opcionais)
    }, [opcionais])


    const handleInputTagsChange = (event) => {
        setDiferenciaisDigitados(event.target.value);
        //handleInputValueChange(event, "outros_diferenciais")
    };

    const handleInputKeyPress = (event) => {
        if (event.key === 'Enter' && diferenciaisDigitados.trim() !== '') {
            const novoDiferencial = diferenciaisDigitados.trim();
            // Se não existir na lista, adiciona à lista de opcionais
            if (!opcionais.some(o => o.label.toLowerCase() === novoDiferencial.toLowerCase())) {
                setOpcionais([...opcionais, { label: novoDiferencial, value: novoDiferencial }]);
            }
            // Adiciona o diferencial personalizado aos selecionados
            setOpcionaisSelecionados([...opcionaisSelecionados, novoDiferencial]);
            setDiferenciaisDigitados('');
        }
    };
    

    const handleTagDelete = (tagIndex) => {
        const newTags = [...opcionaisSelecionados];
        newTags.splice(tagIndex, 1);
        setOpcionaisSelecionados(newTags);

        const deletedTag = opcionaisSelecionados[tagIndex];
        const updatedOptions = optionsDropdown.map(option =>
            option.value === deletedTag ? { ...option, disabled: false } : option
        );
        setOptionsDropdown(updatedOptions);
    };

    useEffect(() => {
        if (configData.opcionais && Array.isArray(configData.opcionais)) {
          const novoArray = configData.opcionais.map(id => {
            const opcionalEncontrado = opcionais.find(o => o.value === id);
            // Se encontrar, retorna o label; caso contrário, mantém o próprio id (ou trata como personalizado)
            return opcionalEncontrado ? opcionalEncontrado.label : id;
          });
          
          if (JSON.stringify(opcionaisSelecionados) !== JSON.stringify(novoArray)) {
            setOpcionaisSelecionados(novoArray);
          }
        }
      }, [configData.opcionais]);
      
    

    // Algo a destacar

    const [destaquesDigitados, setDestaquesDigitados] = useState('');
    const [destaquesSelecionados, setDestaquesSelecionados] = useState([]);

    


    useEffect(() => {
        if (destaquesSelecionados) {
            handleInputValueChange(destaquesSelecionados, "destaques")
        }
    }, [destaquesSelecionados])

    const handleInputKeyPressDestaques = (event) => {
        if (event.key === 'Enter' && destaquesDigitados.trim() !== '') {
            setDestaquesSelecionados([...destaquesSelecionados, destaquesDigitados.trim()]);
            setDestaquesDigitados('');
        }
    };

    const handleTagDeleteDestaques = (tagIndex) => {
        const newTags = [...destaquesSelecionados];
        newTags.splice(tagIndex, 1);
        setDestaquesSelecionados(newTags);
    };

    // Duplicar Diferenciais



    const [componentes, setComponentes] = useState([
        {
            chamada: "",
            descricao: "",
            imagem: ""
        }
    ]);
    const [mostrarBotaoAdd, setMostrarBotaoAdd] = useState(true);


    const handleAddComponente = () => {
        if (componentes.length < 4) { // Verifica se e menor 4
            setComponentes([...componentes, {
                chamada: "",
                descricao: "",
                imagem: ""
            }]); // Adiciona 
            if (componentes.length === 3) { // Verifica se e 3 
                setMostrarBotaoAdd(false); // Se =  3 esconder Add
            }
        }
    };

    const handleDeleteComponente = (index) => {
        const novosComponentes = componentes.filter(item => item !== index); // Remove o componente
        setComponentes(novosComponentes);
        if (!mostrarBotaoAdd && novosComponentes.length < 4) { // Verifica se o botão "Add" está oculto e se  é menor que 4
            setMostrarBotaoAdd(true); // Se for o caso, mostre "Add"
        }
    };

    const handleChangeComponente = (value, i, field) => {
        if (componentes) {
            const inputData = [...componentes]
            inputData[i][field] = value
            setComponentes(inputData)
        }
    }

    useEffect(() => {
        console.log(componentes)
        if (componentes) {
            handleInputValueChange(componentes, "diferenciais")
        }
    }, [componentes])

    const handleImagemTituloProduto = (value, field) => {
        let aux_paginaProduto = { ...configData["pagina_produto"] }
        aux_paginaProduto[field] = value
        console.log(aux_paginaProduto)
        handleInputValueChange(aux_paginaProduto, "pagina_produto")
    }

    const handleImagemPaginaProduto = (image) => {
        handleImagemTituloProduto(image, "imagem")
    }

    const handleImagemTituloBusca = (value, field) => {
        let aux_paginaBusca = { ...configData["pagina_busca"] }
        aux_paginaBusca[field] = value
        console.log(aux_paginaBusca)
        handleInputValueChange(aux_paginaBusca, "pagina_busca")
    }

    const handleImagemBusca = (image) => {
        handleImagemTituloBusca(image, "imagem")
    }



    const [anoFabricacao, setAnoFabricacao] = useState([])
    useEffect(() => {
        if (configData["ano_modelo"]) {
            setAnoFabricacao([
                { label: configData["ano_modelo"], value: configData["ano_modelo"] },
                { label: configData["ano_modelo"] + 1, value: configData["ano_modelo"] + 1 }
            ])
        }
    }, [configData["ano_modelo"]])

    const handlePriceChange = (value) => {
        handleInputValueChange(value, "preco")
    }
    const handleKmChange = (value) => {
        handleInputValueChange(value, "km")
    }

    useEffect(() => {
        if (configData["preco"]) {
            console.log(configData["preco"])
        }
    }, [configData["preco"]])




    const [wrongData, setWrongData] = useState(
        {
            informacoes_iniciais: {
                fields: {
                    marca_id: false,
                    modelo_id: false,
                    ano_modelo: false,
                    ano_fabricacao: false,
                    cor: false,
                    combustivel: false,
                    preco: false,
                    km: false,
                    placa: false,
                    cambio: false,
                    portas: false,
                    tipo_veiculo: false
                },
                allow: true,
                to_allow: "opcionais",
                next: "Options",
                back: ""
            },
            opcionais: {
                fields: {

                },
                allow: false,
                to_allow: "detalhes",
                next: "Detail",
                back: "Information"
            },
            detalhes: {
                fields: {
                    titulo: false,
                    chamada: false,
                    descricao: false,
                    detalhes_interno: false,
                    detalhes_externo: false
                },
                allow: false,
                to_allow: "fotos",
                next: "Photo",
                back: "Options"
            },
            fotos: {
                fields: {

                },
                allow: false,
                to_allow: "videos_links",
                next: "Upload",
                back: "Detail"
            },
            videos_links: {
                fields: {

                },
                allow: false,
                to_allow: "",
                next: "",
                back: "Photo"
            }
            // ,
            // seo: {
            //     fields: {

            //     },
            //     allow: false,
            //     to_allow: "",
            //     next: "",
            //     back: "Upload"
            // }
        }
    )

    const [disabledOpcionais, setDisabledOpcionais] = useState(true);
    const [disabledDetalhes, setDisabledDetalhes] = useState(true);
    const [disabledFotos, setDisabledFotos] = useState(true);
    const [disabledVideo, setDisabledVideo] = useState(true);
    const [disabledSeo, setDisabledSeo] = useState(true);


    const checkDisableds = () => {


        if (wrongData.opcionais.allow) {
            setDisabledOpcionais(false)
        }

        if (wrongData.detalhes.allow) {
            setDisabledDetalhes(false)
        }

        if (wrongData.fotos.allow) {
            setDisabledFotos(false)
        }

        if (wrongData.videos_links.allow) {
            setDisabledVideo(false)
        }

        // if (wrongData.seo.allow) {
        //     setDisabledSeo(false)
        // }

    }

    useEffect(() => {
        if (wrongData) {
            console.log("[WRONG_DATA]:", wrongData)
            checkDisableds()
        }
    }, [wrongData])

    const handleCheckMandatoryFields = (phase) => {

        console.log(phase, wrongData)
        const phaseData = wrongData[phase];

        if (!phaseData) {
            console.error(`Phase '${phase}' não encontrada em wrongData`);
            return;
        }

        const fields = phaseData.fields;

        let allAreFalse = false;
        let fieldSize = Object.keys(wrongData[phase].fields).length
        let currentAmountOfFalse = 0;

        Object.keys(wrongData[phase].fields).forEach((key, index) => {

            const field = fields[key];

            console.log(key, field)
            console.log(`[configData[${key}]]:${configData[key]}`, typeof configData[key] == 'undefined', configData[key] == '')

            if (typeof configData[key] == 'undefined' || configData[key] == '') {

                setWrongData(prevState => ({
                    ...prevState,
                    [phase]: {
                        ...prevState[phase],
                        fields: {
                            ...prevState[phase].fields,
                            [key]: true
                        }
                    }
                }
                ))

            } else {

                setWrongData(prevState => ({
                    ...prevState,
                    [phase]: {
                        ...prevState[phase],
                        fields: {
                            ...prevState[phase].fields,
                            [key]: false
                        }
                    }
                }
                ))

                currentAmountOfFalse++;

                // console.log(currentAmountOfFalse, fieldSize)

                // if (currentAmountOfFalse == fieldSize) {
                //     allAreFalse = true
                // }
            }
        })


        if (currentAmountOfFalse === fieldSize) {
            setWrongData(prevState => ({
                ...prevState,
                [phase]: {
                    ...prevState[phase],
                    allow: true
                }
            }
            ))

            setWrongData(prevState => ({
                ...prevState,
                [wrongData[phase].to_allow]: {
                    ...wrongData[wrongData[phase].to_allow],
                    allow: true
                }
            }
            ))

            Phases(wrongData[phase].next)
        } else {
            handleAlert('Informações Insuficientes', `Favor verificar os campos obrigatórios`, 'danger')
        }
    }

    const handleCheckMandatoryDetailsFields = (phase) => {

        console.log(phase, wrongData)
        const phaseData = wrongData[phase];

        if (!phaseData) {
            console.error(`Phase '${phase}' não encontrada em wrongData`);
            return;
        }

        const fields = phaseData.fields;

        let allAreFalse = false;
        let fieldSize = Object.keys(wrongData[phase].fields).length
        let currentAmountOfFalse = 0;

        Object.keys(wrongData[phase].fields).forEach((key, index) => {

            const field = fields[key];

            console.log(key, field)
            console.log(`[configData["detalhes"][${key}]]:${configData["detalhes"][key]}`, typeof configData['detalhes'][key] == 'undefined', configData['detalhes'][key] == '')

            if (typeof configData['detalhes'][key] == 'undefined' || configData['detalhes'][key] == '') {

                setWrongData(prevState => ({
                    ...prevState,
                    [phase]: {
                        ...prevState[phase],
                        fields: {
                            ...prevState[phase].fields,
                            [key]: true
                        }
                    }
                }
                ))

            } else {

                setWrongData(prevState => ({
                    ...prevState,
                    [phase]: {
                        ...prevState[phase],
                        fields: {
                            ...prevState[phase].fields,
                            [key]: false
                        }
                    }
                }
                ))

                currentAmountOfFalse++;

                // console.log(currentAmountOfFalse, fieldSize)

                // if (currentAmountOfFalse == fieldSize) {
                //     allAreFalse = true
                // }
            }
        })


        if (currentAmountOfFalse === fieldSize) {
            setWrongData(prevState => ({
                ...prevState,
                [phase]: {
                    ...prevState[phase],
                    allow: true
                }
            }
            ))

            setWrongData(prevState => ({
                ...prevState,
                [wrongData[phase].to_allow]: {
                    ...wrongData[wrongData[phase].to_allow],
                    allow: true
                }
            }
            ))

            Phases(wrongData[phase].next)
        } else {
            handleAlert('Informações Insuficientes', `Favor verificar os campos obrigatórios`, 'danger')
        }
    }

    const checkNotDisabled = (fieldBool, disabledClass) => {
        if (fieldBool) {
            return disabledClass
        } else {
            return ''
        }
    }

    const modules = {
        toolbar: [
            ['bold', 'italic'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }]
        ],
    };

    const [tooltipContent, setTooltipContent] = useState('');

    const handleMouseEnter = (content) => {
        setTooltipContent(content);
    };

    //IA

    useEffect(() => {
        if (intDetail) {
            handleCarData();
        }
    }, [intDetail]);

    const [carData, setCarData] = useState({ modelo: '', marca: '', ano: '' });

    const handleCarData = () => {

        const modeloId = configData["modelo_id"];
        const modelo = modelos.find(item => item.value === modeloId);
        console.log(modelo.label)

        const marcaId = configData["marca_id"];
        const marca = marcas.find(item => item.value === marcaId);
        console.log(marca.label)

        const ano = configData["ano_modelo"];
        console.log(ano)

        const carInfo = `${marca ? marca.label : ''} ${modelo ? modelo.label : ''} ${ano ? ano : ''}`;
        setCarData(carInfo);

    };

    const handleModelResponse = (response) => {
        try {
            // Limpe os campos em configData
            setConfigData(prevData => ({
                ...prevData,
                detalhes: {
                    ...prevData.detalhes,
                    titulo: '',
                    chamada: '',
                    detalhes_externo: '',
                    detalhes_interno: '',
                    descricao: ''
                },

            }));
            const parsedResponse = JSON.parse(response);

            const { titulo, chamada, exterior, interior, descricao } = parsedResponse;

            const exteriorHTML = (
                <ul>
                    {exterior.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            );
            const interiorHTML = (
                <ul>
                    {interior.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            );
            const interiorHTMLString = ReactDOMServer.renderToStaticMarkup(interiorHTML);
            const exteriorHTMLString = ReactDOMServer.renderToStaticMarkup(exteriorHTML);

            console.log("interiorHTML", interiorHTMLString);

            setConfigData(prevData => ({
                ...prevData,
                detalhes: {
                    ...prevData.detalhes,
                    titulo: titulo || '',
                    chamada: chamada || '',
                    detalhes_externo: exteriorHTMLString || <ul></ul>, // Valor padrão para interiorHTML
                    detalhes_interno: interiorHTMLString || <ul></ul>, // Valor padrão para interiorHTML
                    descricao: descricao || ''
                },
                // Atualize outros campos de configData, se necessário
            }));
        } catch (error) {
            console.error("Erro ao analisar a resposta como JSON:", error);
        }
    };

    const [loadingIA, setLoadingIA] = useState(false);

    const setLoadingStatus = (status) => {
        setLoadingIA(status);
    };

    // Edição

    useEffect(() => {
        if (id) {
            fetchVeiculo(id); 
        }
    }, [id]);

    const fetchVeiculo = async (veiculoId) => {
        try {
            const response = await api.get(`/api/veiculos/${veiculoId}`, {
                headers: { 'Authorization': process.env.REACT_APP_API_KEY }
            });
    
            if (response.data) {
                console.log("fetchVeiculo", response.data);

                const decodeHTML = (str) => {
                    const txt = document.createElement("textarea");
                    txt.innerHTML = str;
                    return txt.value;
                };
    
                setConfigData(prev => ({
                ...prev,
                ...response.data,
                cor: response.data.cor_id || "",
                cambio: response.data.cambio_id || "",
                portas: response.data.portas || "",
                combustivel: response.data.combustivel_id || "",
                tipo_veiculo: Number(response.data?.tipo_veiculo ?? 1),
                detalhes: {
                    ...response.data.detalhes,
                    detalhes_interno: normalizeHtmlField(response.data.detalhes?.detalhes_interno),
                    detalhes_externo: normalizeHtmlField(response.data.detalhes?.detalhes_externo),
                    // titulo/chamada/descricao se precisar:
                    titulo: normalizeHtmlField(response.data.detalhes?.titulo),
                    chamada: normalizeHtmlField(response.data.detalhes?.chamada),
                    descricao: normalizeHtmlField(response.data.detalhes?.descricao),
                }
                }));

                if (Array.isArray(response.data.fotos)) {
                handleInputValueChange(
                    response.data.fotos.map(f => ({
                    id: f.id,
                    imagem: f.imagem || f.src || "" // garante campo imagem
                    })),
                    "fotos"
                );
                }
    
                if (response.data.videos && response.data.videos.length > 0) {
                    setInputs(response.data.videos);
                } else {
                    setInputs(['']); // valor padrão
                }
    
                if (response.data.som && response.data.som.length > 0) {
                    setSoms(response.data.som);
                } else {
                    setSoms(['']); // valor padrão
                }
    
                // Atualiza os diferenciais
                if (response.data.diferenciais && response.data.diferenciais.length > 0) {
                    setComponentes(response.data.diferenciais);
                } else {
                    setComponentes([]);
                }
            }
        } catch (error) {
            console.error("Erro ao buscar dados do veículo:", error);
        }
    };
    
    const [tags, setTags] = useState([]);
    const saveButton = useRef(null)

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Evita que o formulário seja enviado ao pressionar Enter
            const newTag = inputValue.trim();
            if (newTag && tags.length < 4) { // Verifica se há menos de 4 tags
                setTags([...tags, newTag]);
                setInputValue('');
            }
        }
    };

    useEffect(() => {
        if (tags) {
            handleInputValueChange(tags, "palavras_chave")
        }
    }, [tags])

    const handleRemoveTag = (indexToRemove) => {
        setTags(tags.filter((tag, index) => index !== indexToRemove));
    };

    useEffect(() => {
        setIsChecked(!!configData?.blindagem?.blindado);
    }, [configData?.blindagem?.blindado]);
    

    useEffect(() => {
    handleInputValueChange({
        blindado: isChecked ? 1 : 0,
        tipo_blindagem: isChecked ? (configData?.blindagem?.tipo_blindagem ?? "") : "",
        tipo_vidro: isChecked ? (configData?.blindagem?.tipo_vidro ?? "") : "",
        garantia_vidro: isChecked ? (configData?.blindagem?.garantia_vidro ?? "") : ""
    }, "blindagem");
    }, [isChecked]);


    const mapToId = (options, val) => {
        if (val == null) return null;
        if (typeof val === "number") return val; // já é id
        const found = options.find(o => (o.label || "").toLowerCase() === String(val).toLowerCase());
        return found ? found.value : null;
    };

    // depois de carregar as listas, normalize configData.blindagem
    useEffect(() => {
    if (!configData?.blindagem) return;
    if (!blindagem.length || !vidros.length || !garantia.length) return;

    setConfigData(prev => ({
        ...prev,
        blindagem: {
        ...prev.blindagem,
        tipo_blindagem: mapToId(blindagem, prev.blindagem?.tipo_blindagem),
        tipo_vidro: mapToId(vidros, prev.blindagem?.tipo_vidro),
        garantia_vidro: mapToId(garantia, prev.blindagem?.garantia_vidro),
        }
    }));
    }, [blindagem, vidros, garantia]);


    // opcional: se usar DOMPurify, importe: import DOMPurify from 'dompurify';

    const normalizeHtmlField = (value) => {
    if (!value) return "";

    // vira string e tira aspas envolventes, se existirem
    let s = String(value).trim();
    if ((s.startsWith('"') && s.endsWith('"')) || (s.startsWith("'") && s.endsWith("'"))) {
        s = s.slice(1, -1);
    }

    // colapsa sequências longas de barras invertidas e remove escapes de aspas
    s = s.replace(/\\\\+/g, "\\").replace(/\\"/g, '"').replace(/\\'/g, "'");

    // decodifica entidades HTML repetidamente (até estabilizar)
    const txt = document.createElement("textarea");
    let last;
    do {
        last = s;
        txt.innerHTML = s;
        s = txt.value;
    } while (s !== last && /&(?:lt|gt|amp|quot|apos|#[0-9]+);/i.test(s));

    // sanitize (recomendado)
    // s = DOMPurify.sanitize(s);

    return s;
    };



    return (
        <>
            <Navbar />
            <div className="Content Veiculos">
                <Container fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <div className='NavVeiculos'>
                                <ul>
                                    <li>
                                        <a onClick={() => (isEditing || wrongData.informacoes_iniciais.allow) && Phases("Information")} 
                                        className={`${intInformation ? 'active' : ''}`}>
                                            <i><Icon className="icons" icon="fa-solid:car" /></i>
                                            <span>INFORMAÇÕES <br />INICIAIS</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a onClick={() => (isEditing || wrongData.opcionais.allow) && Phases("Options")} 
                                        className={`${intOptions ? 'active' : ''} ${isEditing ? "" : disabledOpcionais ? "disabled-phase" : ""}`}>
                                            <i><Icon className="icons" icon="mdi:car-seat" /></i>
                                            <span>OPCIONAIS <br />&nbsp;</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a onClick={() => (isEditing || wrongData.detalhes.allow) && Phases("Detail")} 
                                        className={`${intDetail ? 'active' : ''} ${isEditing ? "" : disabledDetalhes ? "disabled-phase" : ""}`}>
                                            <i><Icon className="icons" icon="mingcute:car-window-fill" /></i>
                                            <span>DETALHES <br />&nbsp;</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a onClick={() => (isEditing || wrongData.fotos.allow) && Phases("Photo")} 
                                        className={`${intPhoto ? 'active' : ''} ${isEditing ? "" : disabledFotos ? "disabled-phase" : ""}`}>
                                            <i><Icon className="icons" icon="mingcute:pic-fill" /></i>
                                            <span>FOTOS <br />&nbsp; </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a onClick={() => (isEditing || wrongData.videos_links.allow) && Phases("Upload")} 
                                        className={`${intUpload ? 'active' : ''} ${isEditing ? "" : disabledVideo ? "disabled-phase" : ""}`}>
                                            <i><Icon className="icons" icon="fluent:video-32-filled" /></i>
                                            <span>VÍDEOS E LINKS <br />&nbsp; </span>
                                        </a>
                                    </li>
                                    {isEditing  && (
                                    <li>
                                        <a onClick={() => (isEditing || wrongData.seo.allow) && Phases("Seo")} 
                                        className={`${intSeo ? 'active' : ''} ${isEditing ? "" : disabledSeo ? "disabled-phase" : ""}`}>
                                            <i><Icon className="icons" icon="icon-park-outline:search" /></i>
                                            <span>SEO<br />&nbsp; </span>
                                        </a>
                                    </li>
                                    )}
                                </ul>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            {intInformation &&
                                <div className='Novo'>
                                    <Row className='justify-content-center'>
                                        <Col xs={12} sm={12} md={10} lg={9}>
                                            <div className='HeaderNovo'>
                                                <h2><i><Icon icon="fa-solid:car"></Icon></i> Informações iniciais</h2>
                                                <div className='statusMultiplos'>
                                                    <span className={statusMultiplos}></span>
                                                    <ul>
                                                        <li className={statusMultiplos === 'on' ? 'ativo' : ''} onClick={() => handleClickStatusMultiplos('on')}>ON</li>
                                                        <li className={statusMultiplos === 'off' ? 'ativo' : ''} onClick={() => handleClickStatusMultiplos('off')}>OFF</li>
                                                        <li className={statusMultiplos === 'vendido' ? 'ativo' : ''} onClick={() => handleClickStatusMultiplos('vendido')}>Vendido</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={10} lg={9}>
                                            <Form.Group className="FormNovo">
                                                <Row>
                                                    <Col xs={12} sm={12} md={6} lg={6}>
                                                        <Form.Label className='Label'>
                                                        <span>Situação</span>
                                                        <Dropdown
                                                            value={configData["situacao"]}
                                                            onChange={(e) => handleInputChange(e, "situacao")}
                                                            options={[
                                                            { label: "Novo", value: "novo" },
                                                            { label: "Usado", value: "usado" }
                                                            ]}
                                                            optionLabel="label"
                                                            placeholder="Selecione a situação"
                                                            className='Dropdown'
                                                        />
                                                        </Form.Label>
                                                    </Col>

                                                    {/* NOVO CAMPO: Tipo de veículo */}
                                                    <Col xs={12} sm={12} md={6} lg={6}>
                                                        <Form.Label className='Label'>
                                                        <span>Tipo de veículo</span>
                                                        <div className={wrongData["informacoes_iniciais"]?.fields?.tipo_veiculo && !configData["tipo_veiculo"] ? 'wrongField' : ''}>
                                                            <Dropdown
                                                            value={configData["tipo_veiculo"]}
                                                            onChange={(e) => handleInputChange(e, "tipo_veiculo")}
                                                            options={[
                                                                { label: "Carro", value: 1 },
                                                                { label: "Moto",  value: 2 }
                                                            ]}
                                                            optionLabel="label"
                                                            placeholder="Selecione o tipo"
                                                            className='Dropdown'
                                                            />
                                                        </div>
                                                        </Form.Label>
                                                    </Col>
                                                    </Row>
                                                <Row>
                                                    <Col xs={12} sm={12} md={6} lg={6}>
                                                        <Form.Label className="Label">
                                                            <span>Placa</span>
                                                            <div className={wrongData["informacoes_iniciais"]["fields"]["placa"] && !configData["placa"] ? "wrongField" : ""}>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Digite a placa do veículo"
                                                                    value={configData["placa"] || ""}
                                                                    onChange={(e) => handleInputChange({ value: e.target.value }, "placa")}
                                                                    className="Inputs"
                                                                />
                                                            </div>
                                                        </Form.Label>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={6} lg={6}>
                                                        <Form.Label className='Label'>
                                                            <span>Escolha a marca </span>
                                                            <div className={wrongData["informacoes_iniciais"]["fields"]["marca_id"] && !configData["marca_id"] ? 'wrongField' : ''}>
                                                                <Dropdown 
                                                                    filter 
                                                                    value={configData["marca_id"] || null} 
                                                                    onChange={(e) => handleInputChange(e, "marca_id")} 
                                                                    options={marcas} 
                                                                    optionLabel="label" 
                                                                    placeholder="Escolha a marca" 
                                                                    className='Dropdown' 
                                                                />
                                                            </div>
                                                        </Form.Label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                   
                                                    <Col xs={12} sm={12} md={6} lg={6}>
                                                        <Form.Label className='Label'>
                                                            <span>Escolha o modelo</span><div onClick={() => {showModal()}} className='naoEncontrol'>Não encontrou?</div>
                                                            <div className={wrongData["informacoes_iniciais"]["fields"]["modelo_id"] && !configData["modelo_id"] ? 'wrongField' : ''}>
                                                                <Dropdown emptyMessage="Sem resultado" filter value={configData["modelo_id"]} onChange={(e) => { handleInputChange(e, "modelo_id") }} options={modelos} optionLabel="label" placeholder="Escolha o Modelo" className='Dropdown' disabled={!configData["marca_id"]}  />
                                                            </div>
                                                        </Form.Label>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={6} lg={6}>
                                                        <Form.Label className='Label'>
                                                            <span>Escolha a versão</span>
                                                            <Dropdown 
                                                                filter 
                                                                value={configData["versao_id"] || null} 
                                                                onChange={(e) => handleInputChange(e, "versao_id")} 
                                                                options={versoes} 
                                                                optionLabel="label" 
                                                                placeholder="Selecione a versão" 
                                                                className='Dropdown' 
                                                                disabled={!configData["modelo_id"]} // Bloqueia até escolher um modelo
                                                            />
                                                        </Form.Label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    
                                                    <Col xs={12} sm={12} md={6} lg={6}>
                                                        <Form.Label className='Label'>
                                                            <span>Escolha o ano de fabricação</span>
                                                            <div className={wrongData["informacoes_iniciais"]["fields"]["ano_modelo"] && !configData["ano_modelo"] ? 'wrongField' : ''}>
                                                                <Dropdown emptyMessage="Sem resultado" value={configData["ano_modelo"]} onChange={(e) => { handleInputChange(e, "ano_modelo") }} options={anosModelo} optionLabel="label" placeholder="Ano de Fabricação" className='Dropdown' />
                                                            </div>
                                                        </Form.Label>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={6} lg={6}>
                                                        <Form.Label className='Label'>
                                                            <span>Escolha o ano do modelo</span>
                                                            <div className={wrongData["informacoes_iniciais"]["fields"]["ano_fabricacao"] && !configData["ano_fabricacao"] ? 'wrongField' : ''}>
                                                                <Dropdown emptyMessage="Sem resultado" value={configData["ano_fabricacao"]} onChange={(e) => {
                                                                    handleInputChange(e, "ano_fabricacao")
                                                                }} options={anoFabricacao} optionLabel="label" placeholder="Ano do Modelo" className='Dropdown' />
                                                            </div>
                                                        </Form.Label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                <Col xs={12} sm={12} md={6} lg={6}>
                                                    <Form.Label className='Label'>
                                                        <span>Escolha uma cor</span>
                                                        <div className={wrongData["informacoes_iniciais"]["fields"]["cor"] && !configData["cor"] ? 'wrongField' : ''}>
                                                            <Dropdown
                                                                emptyMessage="Sem resultado"
                                                                filter
                                                                value={configData["cor"]} // Valor atual selecionado
                                                                onChange={(e) => { handleInputChange(e, "cor"); }} // Atualiza o estado ao selecionar
                                                                options={cores} // Array de opções com { label, value }
                                                                optionLabel="label" // Define que o texto visível será o campo "label"
                                                                placeholder="Cor"
                                                                className='Dropdown'
                                                            />
                                                        </div>
                                                    </Form.Label>
                                                </Col>
                                                <Col xs={12} sm={12} md={6} lg={6}>
                                                    <Form.Label className='Label'>
                                                        <span>Escolha o tipo do câmbio</span>
                                                        <div className={wrongData["informacoes_iniciais"]["fields"]["cambio"] && !configData["cambio"] ? 'wrongField' : ''}>
                                                            <Dropdown
                                                                emptyMessage="Sem resultado"
                                                                filter
                                                                value={configData["cambio"]} // Valor atual selecionado
                                                                onChange={(e) => { handleInputChange(e, "cambio"); }} // Atualiza o estado ao selecionar
                                                                options={cambio} // Array de opções com { label, value }
                                                                optionLabel="label" // Define que o texto visível será o campo "label"
                                                                placeholder="Câmbio"
                                                                className='Dropdown'
                                                            />
                                                        </div>
                                                    </Form.Label>
                                                </Col>
                                                <Col xs={12} sm={12} md={6} lg={6}>
                                                    <Form.Label className='Label'>
                                                        <span>Quantidade de Portas</span>
                                                        <div className={wrongData["informacoes_iniciais"]["fields"]["portas"] && !configData["portas"] ? 'wrongField' : ''}>
                                                            <Dropdown
                                                                emptyMessage="Sem resultado"
                                                                filter
                                                                value={configData["portas"]} // Valor atual selecionado
                                                                onChange={(e) => { handleInputChange(e, "portas"); }} // Atualiza o estado ao selecionar
                                                                options={portas} // Array de opções com { label, value }
                                                                optionLabel="label" // Define que o texto visível será o campo "label"
                                                                placeholder="Portas"
                                                                className='Dropdown'
                                                            />
                                                        </div>
                                                    </Form.Label>
                                                </Col>
                                                    <Col xs={12} sm={12} md={6} lg={6}>
                                                        <Form.Label className="Label">
                                                            <span>Escolha o tipo de combustível</span>
                                                            <div className={wrongData["informacoes_iniciais"]["fields"]["combustivel"] && !configData["combustivel"] ? "wrongField" : ""}>
                                                                <Dropdown
                                                                    emptyMessage="Sem resultado"
                                                                    filter
                                                                    value={configData["combustivel"]} // Valor selecionado
                                                                    onChange={(e) => handleInputChange(e, "combustivel")} // Atualiza o estado ao selecionar
                                                                    options={combustivelList} // Dados dinâmicos da API
                                                                    optionLabel="label" // Exibe o campo 'label' no dropdown
                                                                    placeholder="Escolha o Combustível"
                                                                    className="Dropdown"
                                                                />
                                                            </div>
                                                        </Form.Label>
                                                    </Col>

                                                        {/* Switch */}
                                                    <Col xs={12} sm={12} md={6} lg={12}>
                                                        <Form.Check
                                                            className="Label"
                                                            type="switch"
                                                            label="O veículo é blindado?"
                                                            checked={isChecked}
                                                            onChange={handleCheckChange}
                                                        />
                                                    </Col>

                                                    {isChecked && (
                                                    <>
                                                        {/* Tipo de vidro */}
                                                        <Col xs={12} sm={12} md={6} lg={3}>
                                                        <Form.Label className="Label">
                                                            <span>Tipo de vidro</span>
                                                            <div onClick={showModalVidros} className="naoEncontrol">Não encontrou?</div>
                                                    <Dropdown
                                                    filter
                                                    emptyMessage="Sem resultado"
                                                    value={configData?.blindagem?.tipo_vidro ?? null}     // ← deve ser ID
                                                    onChange={(e) =>
                                                        setConfigData(prev => ({
                                                        ...prev,
                                                        blindagem: { ...prev.blindagem, tipo_vidro: e.value } // e.value = ID
                                                        }))
                                                    }
                                                    options={vidros}              // [{ label, value: id }]
                                                    optionLabel="label"
                                                    optionValue="value"           // ← ID
                                                    placeholder="Escolha o tipo de vidro"
                                                    className="Dropdown"
                                                    />
                                                            </Form.Label>
                                                            </Col>

                                                            {/* Garantia do vidro */}
                                                            <Col xs={12} sm={12} md={6} lg={3}>
                                                            <Form.Label className="Label">
                                                                <span>Garantia do vidro</span>
                                                                <div onClick={showModalGarantia} className="naoEncontrol">Não encontrou?</div>
                                                        <Dropdown
                                                            emptyMessage="Sem resultado"
                                                            value={configData?.blindagem?.garantia_vidro ?? null}
                                                            onChange={(e) =>
                                                                setConfigData(prev => ({
                                                                ...prev,
                                                                blindagem: { ...prev.blindagem, garantia_vidro: e.value } // ID
                                                                }))
                                                            }
                                                            options={garantia}            // [{ label, value: id }]
                                                            optionLabel="label"
                                                            optionValue="value"           // ← ID
                                                            placeholder="Escolha a garantia do vidro"
                                                            className="Dropdown"
                                                            />
                                                            </Form.Label>
                                                            </Col>

                                                            {/* Tipo de Blindagem */}
                                                            <Col xs={12} sm={12} md={6} lg={6}>
                                                            <Form.Label className="Label">
                                                                <span>Tipo de Blindagem</span>
                                                                <div onClick={showModalBlindagens} className="naoEncontrol">Não encontrou?</div>
                                                        <Dropdown
                                                        filter
                                                        emptyMessage="Sem resultado"
                                                        value={configData?.blindagem?.tipo_blindagem ?? null}
                                                        onChange={(e) =>
                                                            setConfigData(prev => ({
                                                            ...prev,
                                                            blindagem: { ...prev.blindagem, tipo_blindagem: e.value } // ID
                                                            }))
                                                        }
                                                        options={blindagem}           // [{ label, value: id }]
                                                        optionLabel="label"
                                                        optionValue="value"           // ← ID
                                                        placeholder="Escolha o tipo de blindagem"
                                                        className="Dropdown"
                                                        />
                                                            </Form.Label>
                                                            </Col>
                                                        </>
                                                        )}

                                                </Row>

                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} sm={12} md={10} lg={9}>
                                            <div className='HeaderNovo'>
                                                <h2>conte mais sobre o carro</h2>
                                            </div>
                                        </Col>
                                        
                                        <Col xs={12} sm={12} md={10} lg={9}>
                                            <Form.Group className="FormNovo">
                                                <Row>
                                                    <Col xs={12} sm={12} md={6} lg={6}>
                                                        <Form.Label className='Label'>
                                                            <span>quilometragem</span>
                                                            <div className={wrongData["informacoes_iniciais"]["fields"]["km"] && !configData["km"] ? 'wrongField' : ''}>
                                                                {/* <Form.Control className='Inputs noMarginButtonInput' type="text" value={configData["km"]} onChange={(e) => { handleInputChange(e, "km") }} placeholder="Quanto o carro já rodou?" /> */}
                                                                <KmInput value={configData["km"]} handleChange={handleKmChange}></KmInput>
                                                            </div>
                                                        </Form.Label>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={6} lg={6}>
                                                        <Form.Label className='Label'>
                                                            <span>Preço</span>
                                                            <div className='Fipe'>
                                                                <i></i>
                                                                {(configData["ano_fabricacao"] && configData["combustivel"]) && (
                                                                    <span><strong>FIPE {configData["ano_modelo"]}:</strong> {fipe}</span>
                                                                )}
                                                            </div>
                                                            {/* <Form.Control value={configData["preco"]} onChange={(e) => { handleInputChange(e, "preco") }} className='Inputs' type="text" placeholder="Por quanto quer vender?" /> */}
                                                            <div className={wrongData["informacoes_iniciais"]["fields"]["preco"] && !configData["preco"] ? 'wrongField' : ''}>
                                                                <ReaisInput value={configData["preco"]} handleChange={handlePriceChange}></ReaisInput>
                                                            </div>
                                                        </Form.Label>
                                                    </Col>
                                                </Row>
                                            </Form.Group>
                                        </Col>

                                        <Col xs={12} sm={12} md={10} lg={9}>
                                            <div className='HeaderNovo'>
                                                <h2>Informações adicionais</h2>
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={10} lg={9}>
                                            <Form.Group className="FormNovo">
                                                <Row>

                                                    <Col xs={12} sm={12} md={6} lg={4}>
                                                        <Form.Check 
                                                            className='Label' 
                                                            type="switch" 
                                                            label="Adaptado para PCD"
                                                            checked={configData["adaptado_pcd"] === 1}
                                                            onChange={(e) => handleInputValueChange(e.target.checked ? 1 : 0, "adaptado_pcd")}
                                                        />
                                                    </Col>
                                                    <Col xs={12} sm={12} md={6} lg={4}>
                                                        <Form.Check 
                                                            className='Label' 
                                                            type="switch" 
                                                            label="Único dono"
                                                            checked={configData["unico_dono"] === 1}
                                                            onChange={(e) => handleInputValueChange(e.target.checked ? 1 : 0, "unico_dono")}
                                                        />
                                                    </Col>

                                                    <Col xs={12} sm={12} md={6} lg={4}>
                                                        <Form.Check 
                                                            className='Label' 
                                                            type="switch" 
                                                            label="Alienado"
                                                            checked={configData["alienado"] === 1}
                                                            onChange={(e) => handleInputValueChange(e.target.checked ? 1 : 0, "alienado")}
                                                        />
                                                    </Col>

                                                    <Col xs={12} sm={12} md={6} lg={4}>
                                                        <Form.Check 
                                                            className='Label' 
                                                            type="switch" 
                                                            label="Aceita Troca?"
                                                            checked={configData["troca"] === 1}
                                                            onChange={(e) => handleInputValueChange(e.target.checked ? 1 : 0, "troca")}
                                                        />
                                                    </Col>

                                                    <Col xs={12} sm={12} md={6} lg={4}>
                                                        <Form.Check 
                                                            className='Label' 
                                                            type="switch" 
                                                            label="Revisado na Oficina"
                                                            checked={configData["revisado_oficina"] === 1}
                                                            onChange={(e) => handleInputValueChange(e.target.checked ? 1 : 0, "revisado_oficina")}
                                                        />
                                                    </Col>

                                                    <Col xs={12} sm={12} md={6} lg={4}>
                                                        <Form.Check 
                                                            className='Label' 
                                                            type="switch" 
                                                            label="Revisado na Concessionária"
                                                            checked={configData["revisado_concessionaria"] === 1}
                                                            onChange={(e) => handleInputValueChange(e.target.checked ? 1 : 0, "revisado_concessionaria")}
                                                        />
                                                    </Col>

                                                    <Col xs={12} sm={12} md={6} lg={6}>
                                                        <Form.Check 
                                                            className='Label' 
                                                            type="switch" 
                                                            label="Garantia de Fábrica"
                                                            checked={configData["garantia_fabrica"] === 1}
                                                            onChange={(e) => handleInputValueChange(e.target.checked ? 1 : 0, "garantia_fabrica")}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Form.Group>
                                        </Col>

                                        
                                        <Col xs={12} sm={12} md={8} lg={8} className='text-center'>
                                            <Form.Group className="FormNovo">
                                                {isEditing ? (
                                                     <Button className='Btns ButtonPrimaryLight Salvar' ref={saveButton} onClick={postVeiculo}>
                                                        <ButtonLoadingRing sending={sending} /> Salvar
                                                    </Button>
                                                ) : (
                                                    <Button className='Btns ButtonPrimaryLight' onClick={() => { handleCheckMandatoryFields("informacoes_iniciais") }}>Continuar</Button>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                            }
                            {intOptions &&
                                <div className='Novo'>
                                    <Row className='justify-content-center'>
                                        <Col xs={12} sm={12} md={8} lg={8}>
                                            <div className='HeaderNovo'>
                                                <h2><i><Icon icon="mdi:car-seat"></Icon></i> Opcionais</h2>
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={8} lg={8}>
                                            <Form.Group className="FormNovo">
                                                <Row>
                                                    <Col xs={12} sm={12} md={6} lg={6}>
                                                        <Form.Label className='Label'>
                                                            <span>Selecione os opcionais</span>
                                                            <Dropdown
                                                                filter
                                                                emptyMessage="Sem resultado"
                                                                value={null}
                                                                options={opcionais}
                                                                onChange={handleDropdownChange}
                                                                optionLabel="label"
                                                                placeholder="Opcionais"
                                                                className='Dropdown'
                                                            />
                                                        </Form.Label>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={6} lg={6}>
                                                        <Form.Label className='Label'>
                                                            <span>Outros Diferenciais</span>
                                                            <div className="FormControl Full">
                                                                <Form.Control
                                                                    className='Inputs'
                                                                    type="text"
                                                                    placeholder="Escreva os Diferenciais"
                                                                    value={diferenciaisDigitados}
                                                                    onChange={handleInputTagsChange}
                                                                    onKeyPress={handleInputKeyPress}
                                                                />
                                                                <i><Icon data-tooltip-id="my-tooltip" onMouseEnter={() => handleMouseEnter('Escreva os destaques e dê um enter para incluí-los')} icon="akar-icons:light-bulb"></Icon></i>
                                                            </div>
                                                        </Form.Label>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12} lg={12}>
                                                        <div className='TagsInput'>
                                                            {opcionaisSelecionados.map((tag, index) => {
                                                                const opcionalEncontrado = opcionais.find(o => o.label === tag);
                                                                const opcionalID = opcionalEncontrado ? opcionalEncontrado.value : null;

                                                                return (
                                                                    <span key={index} data-id={opcionalID}> 
                                                                        {tag}
                                                                        <i onClick={() => handleTagDelete(index)}>
                                                                            <Icon icon="iconamoon:close-duotone"></Icon>
                                                                        </i>
                                                                    </span>
                                                                );
                                                            })}
                                                        </div>
                                                    </Col>
                                                </Row>

                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} sm={12} md={8} lg={8}>
                                            <div className='HeaderNovo'>
                                                <h2>Tem algo mais que queira destacar?</h2>
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={8} lg={8}>
                                            <Form.Group className="FormNovo">
                                                <Row>
                                                    <Col xs={12} sm={12} md={12} lg={12}>
                                                        <Form.Label className='Label'>
                                                            <span>outros destaques</span>
                                                            <div className="FormControl Full">
                                                                <Form.Control
                                                                    className='Inputs'
                                                                    type="text"
                                                                    placeholder="Escreva os destaques"
                                                                    value={destaquesDigitados}
                                                                    onChange={(e) => {
                                                                        setDestaquesDigitados(e.target.value)
                                                                        //handleInputValueChange(e.target.value, "destaques")
                                                                    }}
                                                                    onKeyPress={handleInputKeyPressDestaques}
                                                                />
                                                                <i><Icon data-tooltip-id="my-tooltip" onMouseEnter={() => handleMouseEnter('Escreva os destaques e dê um enter para incluí-los')} icon="akar-icons:light-bulb"></Icon></i>
                                                            </div>
                                                        </Form.Label>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12} lg={12}>
                                                        <div className='TagsInput'>
                                                            {destaquesSelecionados.map((destaque, index) => (
                                                                <span key={index}>
                                                                    {destaque}
                                                                    <i onClick={() => handleTagDeleteDestaques(index)}>
                                                                        <Icon icon="iconamoon:close-duotone"></Icon>
                                                                    </i>
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} sm={12} md={8} lg={8} className='text-center'>
                                            <Form.Group className="FormNovo">
                                                <Button className='Btns ButtonSecondary' onClick={() => Phases(wrongData.opcionais.back)} > Voltar</Button>
                                                {isEditing ? (
                                                     <Button className='Btns ButtonPrimaryLight Salvar' ref={saveButton} onClick={postVeiculo}>
                                                        <ButtonLoadingRing sending={sending} /> Salvar
                                                    </Button>
                                                ) : (
                                                    <Button className='Btns ButtonPrimaryLight' onClick={() => { handleCheckMandatoryFields("opcionais") }}>Continuar</Button>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                            }
                            {intDetail &&
                                <div className='Novo'>
                                    <Row className='justify-content-center'>
                                        <Col xs={12} sm={12} md={8} lg={8}>
                                            <div className='HeaderNovo'>
                                                <h2><i><Icon icon="mingcute:car-window-fill"></Icon></i> Detalhes</h2>
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={8} lg={8}>
                                            <Form.Group className="FormNovo">
                                                <Row>
                                                    <Col>

                                                        <GPT carInfo={carData} onModelResponse={handleModelResponse} setLoadingStatus={setLoadingStatus} />
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12} lg={12}>
                                                        <Form.Label className='Label'>
                                                            <span>Título</span>
                                                            <div className="FormControl Full">
                                                                <div className={`loadingIA ${loadingIA == true ? 'active' : ''} ${wrongData["detalhes"]["fields"]["titulo"] && !configData["detalhes"]["titulo"] ? 'wrongField' : ''}`}>
                                                                    <Form.Control
                                                                        className='Inputs'
                                                                        type="text"
                                                                        value={configData["detalhes"]["titulo"]}
                                                                        onChange={(e) =>
                                                                            setConfigData(prevData => ({
                                                                                ...prevData,
                                                                                "detalhes": {
                                                                                    ...prevData.detalhes,
                                                                                    "titulo": e.target.value
                                                                                }
                                                                            }))
                                                                        } placeholder="Título do veículo" />
                                                                </div>
                                                                <i><Icon data-tooltip-id="my-tooltip" onMouseEnter={() => handleMouseEnter('Adicione uma titulo com no máximo 30 caracteres')} icon="akar-icons:light-bulb"></Icon></i>
                                                            </div>
                                                        </Form.Label>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12} lg={12}>
                                                        <Form.Label className='Label'>
                                                            <span>Chamada</span>
                                                            <div className="FormControl Full">
                                                                <div className={`loadingIA ${loadingIA == true ? 'active' : ''} ${wrongData["detalhes"]["fields"]["chamada"] && !configData["detalhes"]["chamada"] ? 'wrongField' : ''}`}>
                                                                    <Form.Control
                                                                        className='Inputs'
                                                                        type="text"
                                                                        value={configData["detalhes"]["chamada"]}
                                                                        onChange={(e) =>
                                                                            // handleInputChange(e, "chamada_pagina")
                                                                            setConfigData(prevData => ({
                                                                                ...prevData,
                                                                                "detalhes": {
                                                                                    ...prevData.detalhes,
                                                                                    "chamada": e.target.value
                                                                                }
                                                                            }))
                                                                        } placeholder="Chamada da página" />
                                                                </div>
                                                                <i><Icon data-tooltip-id="my-tooltip" onMouseEnter={() => handleMouseEnter('Adicione uma chamada com no máximo 140 caracteres')} icon="akar-icons:light-bulb"></Icon></i>
                                                            </div>
                                                        </Form.Label>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12} lg={12}>
                                                        <Form.Label className='Label'>
                                                            <span>Descrição</span>
                                                            <div className={`loadingIA ${loadingIA == true ? 'active' : ''} textarea`}>
                                                                <textarea
                                                                    className={wrongData["detalhes"]["fields"]["descricao"] && !configData["detalhes"]["descricao"] ? 'wrongField' : ''}
                                                                    value={configData["detalhes"]["descricao"]}
                                                                    placeholder="Digite seu texto aqui..."
                                                                    onChange={(e) =>
                                                                        //handleInputChange(e, "descricao")
                                                                        setConfigData(prevData => ({
                                                                            ...prevData,
                                                                            "detalhes": {
                                                                                ...prevData.detalhes,
                                                                                "descricao": e.target.value
                                                                            }
                                                                        }))
                                                                    }></textarea>
                                                            </div>

                                                        </Form.Label>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12} lg={12}>
                                                        <Form.Label className='Label'>
                                                            <span>Detalhes internos</span>
                                                            <ReactQuill
                                                                value={configData.detalhes.detalhes_interno || ""}
                                                                className={`loadingIA quill ${loadingIA ? 'active' : ''} ${wrongData.detalhes.fields.detalhes_interno && !configData.detalhes.detalhes_interno ? 'wrongField' : ''}`}
                                                                modules={modules}
                                                                placeholder="Digite os detalhes internos aqui..."
                                                                onChange={(value) => {
                                                                    setConfigData(prevData => ({
                                                                        ...prevData,
                                                                        detalhes: {
                                                                            ...prevData.detalhes,
                                                                            detalhes_interno: value
                                                                        }
                                                                    }));
                                                                }}
                                                            />
                                                        </Form.Label>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12} lg={12}>
                                                        <Form.Label className='Label'>
                                                            <span>Detalhes externos</span>
                                                            <ReactQuill
                                                                value={configData["detalhes"]["detalhes_externo"]}
                                                                className={`loadingIA quill ${loadingIA == true ? 'active' : ''} ${wrongData["detalhes"]["fields"]["detalhes_externo"] && !configData["detalhes"]["detalhes_externo"] ? 'wrongField' : ''}`}
                                                                modules={modules}
                                                                placeholder="Digite os detalhes externos aqui..."
                                                                dangerouslySetInnerHTML={{ __html: configData["detalhes"]["detalhes_externo"] }}
                                                                onChange={(value) => setConfigData(prevState => ({
                                                                    ...prevState,
                                                                    detalhes: {
                                                                        ...prevState.detalhes,
                                                                        detalhes_externo: value
                                                                    }
                                                                }))}
                                                            />
                                                        </Form.Label>
                                                    </Col>
                                                </Row>

                                            </Form.Group>
                                        </Col>

                                        <Col xs={12} sm={12} md={8} lg={8} className='text-center'>
                                            <Form.Group className="FormNovo">
                                                <Button className='Btns ButtonSecondary' onClick={() => Phases(wrongData.detalhes.back)} >Voltar</Button>
                                                {isEditing ? (
                                                     <Button className='Btns ButtonPrimaryLight Salvar' ref={saveButton} onClick={postVeiculo}>
                                                        <ButtonLoadingRing sending={sending} /> Salvar
                                                    </Button>
                                                ) : (
                                                    <Button className='Btns ButtonPrimaryLight' onClick={() => { handleCheckMandatoryDetailsFields("detalhes") }}>Continuar</Button>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                            }
                            {intPhoto &&
                                <div className='Novo'>
                                    <Row className='justify-content-center'>
                                        <Col xs={12} sm={12} md={8} lg={8}>
                                            <div className='HeaderNovo'>
                                                <h2><i><Icon icon="mingcute:pic-fill"></Icon></i> Fotos</h2>
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={8} lg={8}>
                                            <Form.Group className="FormNovo">
                                                <Row>
                                                    <IdzFileUpload
                                                        multiple
                                                        handleUpload={updateUploadedMultipleFiles}
                                                        currentFile={configData["fotos"]}
                                                    ></IdzFileUpload>
                                                </Row>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} sm={12} md={8} lg={8}>
                                            <div className='HeaderNovo'>
                                                <h2><i><Icon icon="mingcute:pic-fill"></Icon></i> Fotos de destaques</h2>
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={8} lg={8}>
                                            <Form.Group className="FormNovo">
                                                <Row>
                                                    <Col xs={12} sm={12} md={3} lg={6}>
                                                        <label className='labelInfo'><i><Icon icon="material-symbols:info-outline"></Icon></i> Foto em Destaque na <strong> Página do Produto</strong></label>
                                                        <div className="ImagesUploader Full">
                                                            <IdzFileUpload currentFile={configData["pagina_produto"]["imagem"]} handleUpload={handleImagemPaginaProduto}></IdzFileUpload>
                                                            <span>
                                                                <i><Icon className="icons" icon="ph:upload-fill" /></i>
                                                                <h6>Carregar foto</h6>
                                                                <p>Arquivos permitidos: .jpeg, .png</p>
                                                            </span>
                                                        </div>
                                                        <Form.Label className='Label'>
                                                            <div className="FormControl Full">
                                                                <Form.Control className='Inputs' type="text" placeholder="Titulo da Foto" value={configData["pagina_produto"]?.titulo} onChange={(e) => handleImagemTituloProduto(e.target.value, "titulo")} />
                                                                <i><Icon data-tooltip-id="my-tooltip" onMouseEnter={() => handleMouseEnter('Adicione uma descrição com no máximo 80 caracteres')} icon="akar-icons:light-bulb"></Icon></i>
                                                            </div>
                                                        </Form.Label>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={3} lg={6}>
                                                        <label className='labelInfo'><i><Icon icon="material-symbols:info-outline"></Icon></i> Foto em Destaque na <strong>Página de Busca</strong></label>
                                                        <div className="ImagesUploader Full">
                                                            <IdzFileUpload currentFile={configData["pagina_busca"]["imagem"]} handleUpload={handleImagemBusca}></IdzFileUpload>
                                                            <span>
                                                                <i><Icon className="icons" icon="ph:upload-fill" /></i>
                                                                <h6>Carregar foto</h6>
                                                                <p>Arquivos permitidos: .jpeg, .png</p>
                                                            </span>
                                                        </div>
                                                        <Form.Label className='Label'>
                                                            <div className="FormControl Full">
                                                                <Form.Control className='Inputs' type="text" placeholder="Titulo da Foto" value={configData["pagina_busca"]?.titulo} onChange={(e) => handleImagemTituloBusca(e.target.value, "titulo")} />
                                                                <i><Icon data-tooltip-id="my-tooltip" onMouseEnter={() => handleMouseEnter('Adicione uma descrição com no máximo 80 caracteres')} icon="akar-icons:light-bulb"></Icon></i>
                                                            </div>
                                                        </Form.Label>
                                                    </Col>
                                                </Row>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} sm={12} md={8} lg={8}>
                                            <div className='HeaderNovo'>
                                                <h2><i><Icon icon="mingcute:pic-fill"></Icon></i> DIFERENCIAIS</h2>
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={8} lg={8}>
                                            <Form.Group className="FormNovo">
                                                {componentes.map((indice, idx) => (
                                                    <>
                                                        <Row key={idx}>
                                                            <Col xs={12} sm={12} md={3} lg={3}>
                                                                <div className="ImagesUploader">
                                                                    <IdzFileUpload currentFile={configData["diferenciais"][idx]?.imagem} handleDynamicUpload={handleChangeComponente} index={idx} field={"imagem"}></IdzFileUpload>
                                                                    <span>
                                                                        <i><Icon className="icons" icon="ph:upload-fill" /></i>
                                                                        <h6>Carregar foto</h6>
                                                                        <p>Arquivos permitidos: .jpeg, .png</p>
                                                                    </span>
                                                                </div>
                                                            </Col>

                                                            <Col xs={12} sm={12} md={9} lg={idx === 0 ? 9 : 8} className='diferenciais'>
                                                                <Form.Label className='Label'>
                                                                    <Form.Control value={componentes[idx]["chamada"]} onChange={(e) => { handleChangeComponente(e.target.value, idx, "chamada") }} className='Inputs' type="text" placeholder="Chamada da página" />
                                                                </Form.Label>
                                                                <textarea placeholder="Descrição" value={componentes[idx]["descricao"]} onChange={(e) => { handleChangeComponente(e.target.value, idx, "descricao") }} ></textarea>
                                                            </Col>
                                                            <Col xs={12} sm={12} md={12} lg={1} className='text-center'>
                                                                {idx !== 0 && (
                                                                    <Button className='Btns Remove Full' onClick={() => handleDeleteComponente(indice)}>
                                                                        <Icon icon="ic:baseline-minus"></Icon>
                                                                    </Button>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </>
                                                ))}
                                                {mostrarBotaoAdd && (
                                                    <Row>
                                                        <Col xs={12} sm={12} md={12} lg={12} className='text-center'>
                                                            <Button className='Btns Add' onClick={handleAddComponente}>
                                                                <Icon icon="ic:baseline-plus" />
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                )}
                                            </Form.Group>
                                        </Col>

                                        <Col xs={12} sm={12} md={8} lg={8} className='text-center'>
                                            <Form.Group className="FormNovo">
                                                <Button className='Btns ButtonSecondary' onClick={() => Phases(wrongData.fotos.back)} >Voltar</Button>
                                                {isEditing ? (
                                                     <Button className='Btns ButtonPrimaryLight Salvar' ref={saveButton} onClick={postVeiculo}>
                                                        <ButtonLoadingRing sending={sending} /> Salvar
                                                    </Button>
                                                ) : (
                                                    <Button className='Btns ButtonPrimaryLight' onClick={() => { handleCheckMandatoryFields("fotos") }}>Continuar</Button>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} sm={12} md={8} lg={8} className='text-center nao-cadastrar'>
                                            <Form.Group className="FormNovo">
                                                <Button className='Btns ButtonLight'>Quero cadastrar as fotos depois</Button>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                            }
                            {intUpload &&
                                <div className='Novo'>
                                <Row className='justify-content-center'>
                                    <Col xs={12} sm={12} md={8} lg={8}>
                                        <div className='HeaderNovo'>
                                            <h2><i><Icon icon="fluent:video-32-filled"></Icon></i> Vídeos e links</h2>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={12} md={8} lg={8}>
                                        <Form.Group className="FormNovo">
                                            <Row>
                                                <Col xs={12} sm={12} md={12} lg={12}>
                                                    {
                                                        tours.map((tour, index) => (
                                                            <Form.Label className='Label'>
                                                                {index == 0 && <span>Tour virtual</span>}
                                                                <div className="FormControl Full">
                                                                    <Form.Control
                                                                        value={tours[index]}
                                                                        onChange={(e) => handleToursDynamic(e.target.value, index, "tour")}
                                                                        className='Inputs add'
                                                                        type="text"
                                                                        placeholder="Adicione o Link"
                                                                    />
                                                                    <i><Icon icon="ic:baseline-link"></Icon></i>
                                                                </div>
                                                            </Form.Label>
                                                        ))
                                                    }

                                                </Col>
                                                <Row>
                                                    <Col xs={12} sm={12} md={12} lg={2} className="fotoVideo">
                                                        <IdzFileUpload
                                                            currentFile={configData["videos_imagem"]}
                                                            handleUpload={(image) => handleInputValueChange(image, "videos_imagem")}
                                                        />
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12} lg={10}>
                                                        <Col xs={12} sm={12} md={12} lg={12}>
                                                            {inputs.map((input, index) => (
                                                                <Form.Label key={index + 1} className='Label'>
                                                                    {index == 0 && <span>Vídeos</span>}
                                                                    <div className="FormControl">
                                                                        <Form.Control
                                                                            className='Inputs add'
                                                                            type="text"
                                                                            placeholder="Adicione o Link"
                                                                            value={inputs[index]}
                                                                            onChange={(e) => handleInputsDynamic(e.target.value, index, "videos")}
                                                                        />
                                                                        <i><Icon icon="ic:baseline-link"></Icon></i>

                                                                    </div>
                                                                    {index === 0 && (
                                                                        <Button data-tooltip-id="my-tooltip" onMouseEnter={() => handleMouseEnter('Adcionar mais links')} className='Btns Add' onClick={handleAddInput}><Icon icon="ic:baseline-plus"></Icon></Button>
                                                                    )}
                                                                    {(index !== 0) && (
                                                                        <Button data-tooltip-id="my-tooltip" onMouseEnter={() => handleMouseEnter('Excluir esse link')} className='Btns Remove' onClick={() => handleRemoveInput(index)}><Icon icon="ic:baseline-minus"></Icon></Button>
                                                                    )}
                                                                </Form.Label>
                                                            ))}

                                                        </Col>
                                                    </Col>
                                                </Row>
                                            </Row>
                                            <Row>
                                                <Col xs={12} sm={12} md={12} lg={2} className="fotoSom">
                                                    <IdzFileUpload
                                                        currentFile={configData["som_imagem"]}
                                                        handleUpload={(image) => handleInputValueChange(image, "som_imagem")}
                                                    ></IdzFileUpload>
                                                </Col>
                                                <Col xs={12} sm={12} md={12} lg={10}>
                                                    {
                                                        soms.map((som, index) => (
                                                            <Form.Label className='Label'>
                                                                {index == 0 && <span>Som do Motor</span>}
                                                                <div className="FormControl Full">
                                                                    <Form.Control
                                                                        value={soms[index]}
                                                                        onChange={(e) => handleSomsDynamic(e.target.value, index, "som")}
                                                                        className='Inputs add'
                                                                        type="text"
                                                                        placeholder="Adicione o Link"
                                                                    />
                                                                    <i><Icon icon="ic:baseline-link"></Icon></i>
                                                                </div>
                                                            </Form.Label>
                                                        ))
                                                    }

                                                </Col>
                                            </Row>

                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} sm={12} md={8} lg={8} className='text-center'>
                                        <Form.Group className="FormNovo">
                                            {/* <Button className='Btns ButtonSecondary' onClick={() => Phases(wrongData.videos_links.back)} >Voltar</Button> */}
                                            <Button className='Btns ButtonPrimaryLight' ref={saveButton} onClick={postVeiculo}>Salvar</Button>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>
                            }
                            {intSeo && (
                                <div className='Novo'>
                                    <Row className='justify-content-center'>
                                        <Col xs={12} sm={12} md={8} lg={8}>
                                            <div className='HeaderNovo'>
                                                <h2><i><Icon icon="icon-park-outline:search"></Icon></i> SEO - Otimização para Buscadores</h2>
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={8} lg={8}>
                                            <Form.Group className="FormNovo">
                                                <Row>
                                                    <Col xs={12} sm={12} md={12} lg={12}>

                                                        <Form.Label className='Label'>
                                                            <span>URL da Página</span>
                                                            <div className="FormControl Full">
                                                                <Form.Control
                                                                    value={configData["seo"]["url"]}
                                                                    onChange={(e) => setConfigData({
                                                                        ...configData,
                                                                        seo: {
                                                                            ...configData["seo"],
                                                                            url: e.target.value
                                                                        }
                                                                    })}
                                                                    className='Inputs'
                                                                    type="text"
                                                                    placeholder="URL da Página"
                                                                />
                                                                <i><Icon data-tooltip-id="my-tooltip" onMouseEnter={() => handleMouseEnter('Crie uma título com no máximo 50 caracteres')} icon="akar-icons:light-bulb"></Icon></i>
                                                            </div>
                                                        </Form.Label>

                                                        <Form.Label className='Label'>
                                                            <span>Título da Página</span>
                                                            <div className="FormControl Full">
                                                                <Form.Control
                                                                    value={configData["seo"]["titulo"]}
                                                                    onChange={(e) => setConfigData({
                                                                        ...configData,
                                                                        seo: {
                                                                            ...configData["seo"],
                                                                            titulo: e.target.value
                                                                        }
                                                                    })}
                                                                    className='Inputs'
                                                                    type="text"
                                                                    placeholder="Título da Página"
                                                                />
                                                                <i><Icon data-tooltip-id="my-tooltip" onMouseEnter={() => handleMouseEnter('Adicione uma título com no máximo 80 caracteres')} icon="akar-icons:light-bulb"></Icon></i>
                                                            </div>
                                                        </Form.Label>

                                                        <Col xs={12} sm={12} md={4} lg={12}>
                                                            <Form.Label className='Label'>
                                                                <span>Palavras-chaves</span>
                                                                <div className="FormControl Full">
                                                                    <div className='listagem'>
                                                                        {tags.map((tag, index) => (
                                                                            <div key={index} className="tag">
                                                                                {tag}
                                                                                <i onClick={() => handleRemoveTag(index)}>X</i>
                                                                            </div>
                                                                        ))}
                                                                        {tags.length < 4 && (
                                                                            <Form.Control
                                                                                value={inputValue}
                                                                                onChange={(e) => setInputValue(e.target.value)}
                                                                                onKeyDown={handleKeyDown}
                                                                                placeholder="Palavras-chaves"
                                                                            />
                                                                        )}
                                                                    </div>
                                                                    <i><Icon data-tooltip-id="my-tooltip" onMouseEnter={() => handleMouseEnter('Escreva as palavras-chaves e dê um enter para incluí-los')} icon="akar-icons:light-bulb"></Icon></i>
                                                                </div>
                                                            </Form.Label>
                                                        </Col>

                                                        <Col xs={12} sm={12} md={4} lg={12}>
                                                            <Form.Label className='Label'>
                                                                <span>Descrição</span>
                                                                <div className="FormControl Full">
                                                                    <textarea value={configData["seo"]["descricao"]}
                                                                        onChange={(e) => setConfigData({
                                                                            ...configData,
                                                                            seo: {
                                                                                ...configData["seo"],
                                                                                descricao: e.target.value
                                                                            }
                                                                        })} placeholder="Insira sua descrição"></textarea>
                                                                    <i><Icon data-tooltip-id="my-tooltip" onMouseEnter={() => handleMouseEnter('Adicione uma descrição com no máximo 180 caracteres')} icon="akar-icons:light-bulb"></Icon></i>
                                                                </div>
                                                            </Form.Label>
                                                        </Col>

                                                    </Col>
                                                </Row>

                                            </Form.Group>
                                        </Col>

                                        <Col xs={12} sm={12} md={8} lg={8} className='text-center'>
                                            <Form.Group className="FormNovo">
                                                <Button className='Btns ButtonPrimaryLight Salvar' ref={saveButton} onClick={postVeiculo}>
                                                    <ButtonLoadingRing sending={sending} /> Salvar
                                                </Button>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </Col>
                    </Row>
                    <ReactTooltip id="my-tooltip-diferenciais" place="bottom" content="Adicionar mais Diferenciais" style={{ backgroundColor: "#FFFFFF", color: "#000000" }} />
                    <ReactTooltip id="my-tooltip-link" place="bottom" content="Adicionar mais Links" style={{ backgroundColor: "#FFFFFF", color: "#000000" }} />
                    <ReactTooltip id="my-tooltip-remover" place="bottom" content="Remover Link" style={{ backgroundColor: "#FFFFFF", color: "#000000" }} />
                </Container>
                <ReactTooltip id="my-tooltip" place="bottom" content={tooltipContent} />
            </div>
            {isVisible &&
                <Alerts title={isTitle} description={initDescription} type={initType} />
            }
            <NewModelo show={show} handleAlert={handleAlert}/>
            <NewVidros showVidros={showVidros} handleAlert={handleAlert}/>
            <NewBlindagens showBlindagens={showBlindagens} handleAlert={handleAlert}/>
            <NewGarantia showGarantia={showGarantia} handleAlert={handleAlert} />
        </>
    );
}
export default Veiculos;